/**
 * Loading
 *
 */
import React, { Component } from 'react';

/* Component ==================================================================== */
class Loading extends Component {
  static componentName = 'Loading';

  render = () => {
    return (
      <div className="loading site-wrapper site-wrapper-absolute">
        <div className="site-wrapper-inner">
          <div className="cover-container text-center">
            <span className="fas fa-sync"/>
            <h4>Loading...</h4>
          </div>
        </div>
      </div>
    );
  };
}

/* Export Component ==================================================================== */
export default Loading;



// WEBPACK FOOTER //
// ./src/components/general/Loading.js